import Paper from "@mui/material/Paper"
import { styled } from "@mui/material/styles"

export default styled(Paper)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minWidth: "32px",
  minHeight: "32px",
  backgroundColor: "white",
  "& .MuiSvgIcon-root": {
    width: "16px",
    height: "16px",
    fill: theme.palette.colors.gray900,
  },
}))
